import { cssGenerator } from '@yola/ws-sdk';
import isGalleryItem from 'src/js/modules/focal-point/helpers/is-gallery-item';
import isPlaceholder from 'src/js/modules/extensions/registry/ws-image/helpers/is-placeholder';
import getEffectiveResponsiveClassValue from './get-effective-responsive-class-value';
import getEffectiveResponsiveAttribute from './get-effective-responsive-attribute';

const { CONTENT_SCALE } = cssGenerator.constants.attributes;
const { CONTENT_POSITION } = cssGenerator.constants.classNames;

const getMediaContainerData = (mediaElement, breakpoint) => {
  if (!mediaElement) return {};

  return {
    aspectRatio: mediaElement.getAttribute('aspect-ratio'),
    contentPosition: getEffectiveResponsiveClassValue({
      element: mediaElement,
      className: CONTENT_POSITION,
      breakpoint,
    }),
    contentScale: getEffectiveResponsiveAttribute({
      element: mediaElement,
      attr: CONTENT_SCALE,
      breakpoint,
    }),
    mediaGroupId: mediaElement.getAttribute('media-group-id'),
    isPlaceholder: isPlaceholder(mediaElement),
    ...(isGalleryItem(mediaElement)
      ? {
          originSrc: mediaElement.getAttribute('origin-src'),
          originWidth: mediaElement.getAttribute('origin-width'),
          originHeight: mediaElement.getAttribute('origin-height'),
          lightboxDisabled: mediaElement.hasAttribute('lightbox-disabled'),
        }
      : {}),
  };
};

const getImageData = (mediaElement) => {
  const imageElement = mediaElement?.querySelector('img');

  if (!imageElement) return {};

  return {
    src: imageElement.getAttribute('src'),
    alt: imageElement.getAttribute('alt') || '',
    ...(isGalleryItem(mediaElement)
      ? {
          title: imageElement.getAttribute('data-title') || '',
          description: imageElement.getAttribute('data-description') || '',
        }
      : {}),
  };
};

const getIframeData = (mediaElement) => {
  const iframeElement = mediaElement?.querySelector('ws-iframe');

  if (!iframeElement) return {};

  return Object.fromEntries([...iframeElement.attributes].map((attr) => [attr.name, attr.value]));
};

const getDataFromMediaNode = (mediaElement, breakpoint, grouped = false) => {
  const mediaContainerData = getMediaContainerData(mediaElement, breakpoint);
  const iframeData = getIframeData(mediaElement);
  const imageData = getImageData(mediaElement);

  if (grouped) {
    return {
      mediaContainerData,
      imageData,
      iframeData,
    };
  }

  return {
    ...mediaContainerData,
    ...imageData,
    ...iframeData,
  };
};

export default getDataFromMediaNode;
